import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Website Pages
import Home from './pages/Website/Home';

// Footer Pages
import AccountsOverview from './pages/Website/footer_pages/Accountsoverview';
import OpenAccount from './pages/Website/footer_pages/Openaccount';
import LaunchWebTrader from './pages/Website/footer_pages/Launchwebtrader';
import CybersecurityScams from './pages/Website/footer_pages/Cybersecurityscams';
import SpreadsCommissions from './pages/Website/footer_pages/Spreadscommissions';
import RangeOfProducts from './pages/Website/footer_pages/Rangeofproducts';
import TradingHours from './pages/Website/footer_pages/Tradinghours';
import Funding from './pages/Website/footer_pages/Funding';
import Withdrawal from './pages/Website/footer_pages/Withdrawal';
import HelpCentre from './pages/Website/footer_pages/Helpcentre';
import WhyFynessGlobal from './pages/Website/footer_pages/WhyFynessGlobal';
import Regulation from './pages/Website/footer_pages/Regulation';
import LegalDocuments from './pages/Website/footer_pages/Legaldocuments';
import ContactUs from './pages/Website/footer_pages/Contactus';

// Admin Pages
import AdminLayout from './pages/Admin/AdminLayout';
import Login from './pages/Admin/Login';
import Register from './pages/Admin/Register';
import Dashboard from './pages/Admin/Dashboard';
import Profile from './pages/Admin/Profile';
import Deposit from './pages/Admin/Deposit';
import Withdraw from './pages/Admin/Withdraw';
import LiveAccount from './pages/Admin/LiveAccount';
import TransactionHistory from './pages/Admin/TransactionHistory';
import SupportTickets from './pages/Admin/SupportTickets';
import Download from './pages/Admin/Download';
import IBDashboard from './pages/Admin/IBDashboard';
import ReferralLinks from './pages/Admin/ReferralLinks';
import AttractedClients from './pages/Admin/AttractedClients';
import ResetPassword from './pages/Admin/ResetPassword';

// Broker Admin - Auth
import BrokerLogin from './pages/BrokerAdmin/Auth/Login';

// Broker Admin - Layout
import BrokerLayout from './components/BrokerAdmin/Layout/BrokerLayout';

// Broker Admin - Pages
import BrokerDashboard from './pages/BrokerAdmin/Dashboard/Dashboard';
import ClientsList from './pages/BrokerAdmin/Clients/ClientsList';
import DepositsList from './pages/BrokerAdmin/Deposits/DepositsList';
import WithdrawalsList from './pages/BrokerAdmin/Withdrawals/WithdrawalsList';
import KYCQueue from './pages/BrokerAdmin/KYC/KYCQueue';
import WalletsList from './pages/BrokerAdmin/Wallets/WalletsList';
import IBList from './pages/BrokerAdmin/IBManagement/IBList';
import RiskMonitor from './pages/BrokerAdmin/Risk/RiskMonitor';
import PayoutsList from './pages/BrokerAdmin/Payouts/PayoutsList';
import RebatesList from './pages/BrokerAdmin/Rebates/RebatesList';
import ReportsList from './pages/BrokerAdmin/Reports/ReportsList';
import TicketsList from './pages/BrokerAdmin/Tickets/TicketsList';
import SettingsPage from './pages/BrokerAdmin/Settings/SettingsPage';
import MT5Clients from './pages/BrokerAdmin/MT5Clients/MT5Clients';
import PaymentSettings from './pages/BrokerAdmin/PaymentSettings/PaymentSettings';


// Broker Protected Route Component
function BrokerProtectedRoute({ children }) {
  const isBrokerAuthenticated = localStorage.getItem('isBrokerAuthenticated') === 'true';
  const brokerAdmin = localStorage.getItem('brokerAdmin');

  if (!isBrokerAuthenticated || !brokerAdmin) {
    console.log('❌ Broker not authenticated, redirecting to login');
    return <Navigate to="/broker-admin/login" replace />;
  }

  console.log('✅ Broker authenticated');
  return children;
}

function App() {
  return (
    <>
    
      
      <Routes>
        {/* ==================== WEBSITE ROUTES ==================== */}
        
        {/* Website Home Page - Default Route */}
      <Route path="/" element={<Home />} />

      {/* FOOTER PAGES - Forex Trading Section */}
      <Route path="/accounts-overview" element={<AccountsOverview />} />
      <Route path="/open-account" element={<OpenAccount />} />
      <Route path="/launch-web-trader" element={<LaunchWebTrader />} />
      <Route path="/cybersecurity-scams" element={<CybersecurityScams />} />

      {/* FOOTER PAGES - Trading Specifications Section */}
      <Route path="/spreads-commissions" element={<SpreadsCommissions />} />
      <Route path="/range-of-products" element={<RangeOfProducts />} />
      <Route path="/trading-hours" element={<TradingHours />} />
      <Route path="/funding" element={<Funding />} />
      <Route path="/withdrawal" element={<Withdrawal />} />

      {/* FOOTER PAGES - About FynessGlobal Section */}
      <Route path="/help-centre" element={<HelpCentre />} />
      <Route path="/why-FynessGlobal" element={<WhyFynessGlobal />} />
      <Route path="/regulation" element={<Regulation />} />
      <Route path="/legal-documents" element={<LegalDocuments />} />
      <Route path="/contact-us" element={<ContactUs />} />

     

        {/* ==================== AUTHENTICATION ROUTES ==================== */}
        
        {/* Broker Admin Login - Public Route */}
        <Route path="/broker-admin/login" element={<BrokerLogin />} />

        {/* Client Authentication Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* ==================== ADMIN ROUTES ==================== */}
        
        {/* Admin Routes with AdminLayout */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="deposit" element={<Deposit />} />
          <Route path="withdraw" element={<Withdraw />} />
          <Route path="live-account" element={<LiveAccount />} />
          <Route path="transactions" element={<TransactionHistory />} />
          <Route path="support" element={<SupportTickets />} />
          <Route path="download" element={<Download />} />
         
          
          {/* IB Room Routes */}
          <Route path="ib-dashboard" element={<IBDashboard />} />
          <Route path="referral-links" element={<ReferralLinks />} />
          <Route path="attracted-clients" element={<AttractedClients />} />
        </Route>

        {/* ==================== BROKER ADMIN ROUTES ==================== */}
        
        {/* Broker Admin Routes - PROTECTED */}
        <Route path="/broker-admin" element={
          <BrokerProtectedRoute>
            <BrokerLayout />
          </BrokerProtectedRoute>
        }>
          <Route index element={<Navigate to="/broker-admin/dashboard" replace />} />
          <Route path="dashboard" element={<BrokerDashboard />} />
          <Route path="clients" element={<ClientsList />} />
          <Route path="ib-management" element={<IBList />} />
          <Route path="wallets" element={<WalletsList />} />
          <Route path="deposits" element={<DepositsList />} />
          <Route path="withdrawals" element={<WithdrawalsList />} />
          <Route path="kyc" element={<KYCQueue />} />
          <Route path="rebates" element={<RebatesList />} />
          <Route path="payouts" element={<PayoutsList />} />
          <Route path="risk" element={<RiskMonitor />} />
          <Route path="reports" element={<ReportsList />} />
          <Route path="tickets" element={<TicketsList />} />
          <Route path="mt5-clients" element={<MT5Clients />} />
          <Route path="payment-settings" element={<PaymentSettings />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;